import gql from 'graphql-tag';
import { ADMIN_APP_KEY } from '../globals';

export default {
  data() {
    return {
      app: null,
      loadingApp: true,
    };
  },
  computed: {
    appKey() {
      return this.$route.params.app || ADMIN_APP_KEY;
    },
  },
  apollo: {
    app: {
      query: gql`query ($key: String!) {
        app (key: $key) {
          name
          redirect
          url
          key
        }
      }`,
      variables() {
        return {
          key: this.appKey,
        };
      },
      skip() {
        return !this.appKey;
      },
      update(data) {
        this.loadingApp = false;
        return data.app;
      },
    },
  },
};
